'use client';
import React from 'react';
import Link from 'next/link';
import { Home, Map, Plus, Bookmark, User } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


interface BottomNavProps {
  currentPath?: string;
}

const NAV_ITEMS = [
  { href: '/', label: 'Beranda', icon: Home },
  { href: '/jelajahi-explore', label: 'Jelajahi', icon: Map },
  { href: '/simpan-saved', label: 'Simpan', icon: Bookmark },
  { href: '/profil-profile-dashboard', label: 'Profil', icon: User },
];

export default function BottomNav({ currentPath = '/' }: BottomNavProps) {
  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 bg-card border-t border-border z-40 bottom-nav-safe">
      <div className="flex items-center justify-around px-2 py-2">
        {NAV_ITEMS.slice(0, 2).map((item) => {
          const Icon = item.icon;
          const isActive = currentPath === item.href;
          return (
            <Link
              key={`bnav-${item.href}`}
              href={item.href}
              className={`bottom-nav-item ${isActive ? 'active' : ''}`}
            >
              <Icon size={22} strokeWidth={isActive ? 2.5 : 1.8} />
              <span>{item.label}</span>
            </Link>
          );
        })}

        {/* FAB Upload Button */}
        <Link
          href="/sign-up-login-screen"
          className="flex flex-col items-center justify-center w-14 h-14 bg-accent rounded-2xl shadow-fab -mt-6 btn-press"
        >
          <Plus size={26} color="white" strokeWidth={2.5} />
        </Link>

        {NAV_ITEMS.slice(2).map((item) => {
          const Icon = item.icon;
          const isActive = currentPath === item.href;
          return (
            <Link
              key={`bnav-${item.href}`}
              href={item.href}
              className={`bottom-nav-item ${isActive ? 'active' : ''}`}
            >
              <Icon size={22} strokeWidth={isActive ? 2.5 : 1.8} />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}